(function () {
  function initImageCompare(root) {
    if (root._icInit) return;
    root._icInit = true;

    var slider = root.querySelector('[data-slider]');
    var afterContainer = root.querySelector('[data-after-container]');
    var wrapper = slider ? slider.parentElement : null;

    if (!slider || !afterContainer || !wrapper) return;

    var isDragging = false;
    var startPct = parseFloat(root.getAttribute('data-start-position'));
    if (isNaN(startPct)) startPct = 50;

    function setPos(pct) {
      pct = Math.max(0, Math.min(100, pct));
      slider.style.left = pct + '%';
      afterContainer.style.clipPath = 'inset(0 ' + (100 - pct) + '% 0 0)';
    }

    function fromX(clientX) {
      var r = wrapper.getBoundingClientRect();
      setPos((clientX - r.left) / r.width * 100);
    }

    setPos(startPct);

    slider.addEventListener('mousedown', function (e) {
      isDragging = true;
      e.preventDefault();
    });
    slider.addEventListener('touchstart', function () {
      isDragging = true;
    }, { passive: true });

    document.addEventListener('mouseup', function () { isDragging = false; });
    document.addEventListener('touchend', function () { isDragging = false; });

    document.addEventListener('mousemove', function (e) {
      if (!isDragging) return;
      e.preventDefault();
      fromX(e.clientX);
    });
    document.addEventListener('touchmove', function (e) {
      if (!isDragging) return;
      e.preventDefault();
      fromX(e.touches[0].clientX);
    }, { passive: false });

    wrapper.addEventListener('click', function (e) {
      if (e.target === slider || slider.contains(e.target)) return;
      fromX(e.clientX);
    });
  }

  function initAll() {
    document.querySelectorAll('[data-after-container]').forEach(function (el) {
      var root = el.parentElement && el.parentElement.parentElement;
      if (root) initImageCompare(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var nodes = mutations[i].addedNodes;
      for (var j = 0; j < nodes.length; j++) {
        if (nodes[j].nodeType === 1 && nodes[j].querySelector && nodes[j].querySelector('[data-after-container]')) {
          initAll();
          return;
        }
      }
    }
  }).observe(document.body, { childList: true, subtree: true });
})();
